import React from 'react';
import { Link } from "react-router-dom";
import "../../../styles/buscador/resultados_busqueda.css"

const Resultados_busqueda = ({ searchQuery, closeModal }) => {

  const linkMappings = {
    // busqueda de la pagina de contacto y/o preguntas frecuentes
    contacto: '/contacto',
    contactar: '/contacto',
    contacta: '/contacto',
    hotmail: '/contacto',
    correo: '/contacto',
    gmail: '/contacto',
    outlook: '/contacto',
    preguntas: '/contacto',
    respuestas: '/contacto',
    "como me contacto con ustedes": '/contacto',
    "como me puedo poner en contacto con ustedes": '/contacto',
    "como me pongo en contacto con ustedes": '/contacto',
    "como ponerme en contacto con ustedes": '/contacto',

    // busqueda de la pagina de servicios
    servicios: '/servicios',
    "que servicios ofrecen": '/servicios',
    "que servicios me ofrecen": '/servicios',
    "que servicios me pueden ofrecen": '/servicios',
    "como me pueden ayudar": '/servicios',
    "como me ayudarian": '/servicios',

    // busqueda de la pagina de servicios
    clientes: '/nuestros-clientes',
    cliente: '/nuestros-clientes',
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className='tittle-modal'>Resultados para "{searchQuery}"</h3>

        <div>
          {searchQuery in linkMappings && (
            <Link className='link-modal' to={linkMappings[searchQuery]}>Aquí encontrarás información relacionada con {searchQuery}</Link>
          )}
        </div>

        <button onClick={closeModal}>Cerrar</button>
      </div>
    </div>
  );
};

export default Resultados_busqueda;
